import { Navigate, useLocation } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "./AuthProvider";

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { loading, token } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="page center">Loading…</div>;
  if (!token) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return <>{children}</>;
};
